export default "__VITE_ASSET__Dyj_p6iX__"